/**
 * Combines multiple callbacks into a single callback that calls each of the given callbacks.
 */
export function combineCallbacks(...callbacksInput) {
    const callbacks = callbacksInput.filter((callback) => !!callback);
    // If there are no callbacks, return undefined.
    if (callbacks.length === 0) {
        return undefined;
    }
    // Optimize the case where there is only one callback.
    if (callbacks.length === 1) {
        return callbacks[0];
    }
    return function (...args) {
        for (const callback of callbacks) {
            callback?.apply(this, args);
        }
    };
}
